import { DataType, HorizontalAlignment, SortOrder } from "devextreme/common";
import { Format } from "devextreme/localization";

type TColumnHeaderFilter = {
  dataSource?: any[];
  allowSearch?: boolean;
  width?: number;
};
export type TDataTableColumn = {
  key?: string;
  headerFilter?: TColumnHeaderFilter;
  dataField?: string;
  dataType?: DataType | "time";
  sortOrder?: SortOrder;
  caption?: string;
  alignment?: HorizontalAlignment;
  visible?: boolean;
  allowSorting?: boolean;
  allowHeaderFiltering?: boolean;
  allowFiltering?: boolean;
  width?: number | string;
  allowGrouping?: boolean;
  calculateCellValue?: (rowData: Object) => string | null;
  calculateDisplayValue?: (rowData: Object) => string | null;
  format?: Format;
  lookup?: {
    dataSource: any[];
    valueExpr: string;
    displayExpr: ((data: any) => string) | string;
  };
  buttons?: any[];
  cellRender?: (d: any) => any;
  columns?: TDataTableColumn[];
  visibleIndex?: number;
  sortIndex?: number;
  allowEditing?: boolean;
  minWidth?: number;
  // calculateFilterExpression?:
  //   | ((
  //       filterValue: any,
  //       selectedFilterOperation: string | null,
  //       target: string
  //     ) => string | (() => any) | Array<any>)
  //   | undefined;
  hasFlag?: boolean;
};

export type TContextMenuAction = "Open In New Tab" | "Open Location";
export type TGridRowContextMenuItem = {
  text: string;
  icon: string;
  type: GridRowContextMenuTypes;
};
export type TGridRowContextMenu = {
  items: TGridRowContextMenuItem[];
  width: number;
  onItemClick: (action: GridRowContextMenuTypes, data?: Object) => void;
};

export enum GridRowContextMenuTypes {
  openLocation = 1,
  openInNewTab = 2,
  /** Navigate to the row's detail page in the current tab. */
  openDetails = 3,
}

// *************** Default Grid Behavior ***************
//
// - allowHeaderFiltering:
//     Enabled (true)
//
// - headerFilter:
//     Enabled (true) with search disabled (allowSearch: false)
//
// - visible:
//     Enabled (true)
//
// - allowSorting:
//     Enabled (true)
//
// - allowFiltering and lookup:
//     - If allowFiltering is true, lookup replaces it.
//     - If allowFiltering is false, lookup is ignored.
//
// - allowGrouping:
//     Enabled (true)
